module.exports = __webpack_public_path__ + "static/media/Screenshot_2-thumb.a712a450.png";